export const GET_LEADS_DASHBOARD_STICKY_COLUMNS = "GET_LEADS_DASHBOARD_STICKY_COLUMNS";
export const GET_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS = "GET_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS";
export const GET_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR = "GET_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR";

export const UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS = "UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS";
export const UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS = "UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_SUCCESS";
export const UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR = "UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS_ERROR";